import { visit } from 'unist-util-visit'

export const htmlDirectives = () => {
  const transform = (tree: any) => {
    visit(
      tree,
      ['textDirective', 'leafDirective', 'containerDirective'],
      ondirective,
    )
  }

  const ondirective = (node: any) => {
    var data = node.data || (node.data = {})
    // var hast = h(node.name, node.attributes)

    data.hName = node.name
    data.hProperties = node.attributes
  }

  return transform
}
